<div class="d-block mb-3">
  <span class="fw-regular" [ngClass]="required && editMode && !carrier ? 'required' : ''">{{ label }}</span>
  @if (!required && editMode) {
    <span class="form-field-optional text-secondary ms-1">(optional)</span>
  }
</div>
@if (carrier || editMode) {
  @if (editMode) {
    <div class="row mb-3">
      <div class="col">
        <app-search [required]="!carrier" [(ngModel)]="carrier" (ngModelChange)="onCarrierChange($event)"
                    [searchFunction]="utils.findCarriers" [resultFormatter]="utils.carrierFormatter"
                    [inputFormatter]="utils.carrierFormatter">
        </app-search>
      </div>
    </div>
  }
  @if (carrier) {
    <div class="card form-group">
      <div class="card-body p-4">
        <div class="row gy-3 mb-3">
          <div class="col-12 col-lg-8 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Name" [includeMargin]="false" [(value)]="carrier.name"
                            [editMode]="editMode && carrierEditMode">
              <input class="input-group rounded form-control" [(ngModel)]="carrier.name" required/>
            </app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="EORI number" [includeMargin]="false" [(value)]="carrier.customsId"
                            [editMode]="editMode && carrierEditMode"
                            [checkForErrors]="true">
              <input class="input-group rounded form-control" required [(ngModel)]="carrier.customsId"/>
            </app-form-field>
          </div>
        </div>
        <div class="row gy-3 mb-3">
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Street" [includeMargin]="false" [(value)]="carrier.address.street"
                            [editMode]="editMode && carrierEditMode" [checkForErrors]="true">
              <input class="input-group rounded form-control" [(ngModel)]="carrier.address.street"
                     [required]="streetRequired"/>
            </app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Number" [includeMargin]="false" [(value)]="carrier.address.number"
                            [editMode]="editMode && carrierEditMode">
              <input class="input-group rounded form-control" [(ngModel)]="carrier.address.number"
                     [required]="streetRequired"/>
            </app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Post office box" [includeMargin]="false" [(value)]="carrier.address.poBox"
                            [editMode]="editMode && carrierEditMode">
              <input class="input-group rounded form-control" [(ngModel)]="carrier.address.poBox"
                     [required]="poBoxRequired"/>
            </app-form-field>
          </div>
        </div>
        <div class="row gy-3 mb-3">
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Postal code" [includeMargin]="false" [(value)]="carrier.address.postCode"
                            [editMode]="editMode && carrierEditMode"
                            [checkForErrors]="true">
              <input class="input-group rounded form-control" [(ngModel)]="carrier.address.postCode"
                     [required]="['POSTAL_CODE', 'POSTAL_CODE_AND_STREET'].includes(countryValidation?.validationCode)"/>
            </app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="City" [includeMargin]="false" [(value)]="carrier.address.city"
                            [editMode]="editMode && carrierEditMode">
              <input class="input-group rounded form-control" [(ngModel)]="carrier.address.city" required/>
            </app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Region" [includeMargin]="false" [(value)]="carrier.address.subDivision"
                            [editMode]="editMode && carrierEditMode"
                            [checkForErrors]="true">
              <input class="input-group rounded form-control" [(ngModel)]="carrier.address.subDivision"/>
            </app-form-field>
          </div>
        </div>
        <div class="row gy-3">
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-country-field [(countryCode)]="carrier.address.country" [editMode]="editMode && carrierEditMode"
                               [includeMargin]="false" (countryCodeChange)="onCountryChange($event)"
                               [required]="true"></app-country-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Telephone" [includeMargin]="false" [(value)]="telephone.identifier"
                            [editMode]="editMode && carrierEditMode"
                            [tooltipTemplateRef]="telephoneTooltip" [checkForErrors]="true">
              <input class="input-group rounded form-control" [(ngModel)]="telephone.identifier"
                     [pattern]="rules.telephoneRegex" title="for example +31 10 123 4567"/>
            </app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Email address" [includeMargin]="false" [(value)]="email.identifier"
                            [editMode]="editMode && carrierEditMode"
                            [checkForErrors]="true">
              <input class="input-group rounded form-control" [(ngModel)]="email.identifier"/>
            </app-form-field>
          </div>
        </div>
        @if (editMode && carrierEditMode) {
          <div class="row mt-3">
            <div class="col-auto ms-auto">
              <button type="button" class="btn btn-outline-secondary" aria-label="Cancel" (click)="cancel()">Cancel
              </button>
            </div>
            <div class="col-auto">
              <button type="button" class="btn btn-primary" (click)="save()">Save</button>
            </div>
          </div>
        }
        @if (editMode && !carrierEditMode) {
          <button type="button" class="btn btn-tertiary position-absolute end-0 top-0 me-2 mt-2 p-2 px-3 text-normal"
                  (click)="toggleEditMode()">
            <i class="fa fa-fw fa-light fa-pencil"></i>
            Edit
          </button>
        }
      </div>
    </div>
  }
} @else {
  <span class="d-block mb-3">N/A</span>
}
<ng-template #telephoneTooltip>
  <div class="text-start">
    <h6>Telephone Number</h6>
    <p>The number should have format: +31101234567</p>
  </div>
</ng-template>
